import SolutionsView from './SolutionsView';

export default SolutionsView;
